import { defineStore } from "pinia";
import { getApiAxios } from "~/helpers";
import api from "~/config/extensionsApi";

interface ShippingMethodParams {
    skus:string,
    province_id:string,
    amount_order?:number,
    loyalty_point?:number,
}

export const useShippingStore = defineStore("shipping", {
  state: () => ({
    shippings: [],
  }),

  getters: {
    getShippingMethod(state) {
      return state.shippings;
    },
  },
  actions: {
    async getShippings(params: ShippingMethodParams) {
      try {
        const response = await getApiAxios(api.stock.stock_get_stock_by_province, {}, params);
        this.shippings = response.result;
      } catch (error) {
        console.error("Error fetching layouts:", error);
      }
    },
  },
});
